﻿<script>
	export let id;
	export let value;
	export let optionList;
	export let textProperty = "name";
	export let valueProperty = "id";
	export let showHead = true;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
</script>

<select {id} bind:value {disabled} {readonly} {required} class="form-control">
	{#if showHead == true}
		<option value="">Select...</option>
	{/if}
	{#each optionList as item}
		<option value={item[valueProperty]} selected={item[valueProperty] == value}>{item[textProperty]}</option>
	{/each}
</select>
